import { render } from "./GuestRegistration.vue?vue&type=template&id=52f2b6bb&scoped=true&ts=true"
import script from "./GuestRegistration.vue?vue&type=script&lang=ts"
export * from "./GuestRegistration.vue?vue&type=script&lang=ts"

import "./GuestRegistration.vue?vue&type=style&index=0&id=52f2b6bb&lang=scss&scoped=true"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f2b6bb"]])

export default __exports__